import React from "react";

import { StldToggleSwitch, CheckBoxWrapper, CheckBox, CheckBoxLabel } from '../../styled-components/StyledToggleSwitch.style';

export const ToggleSwitchFilters = ({ config, setStatus }) => {

    const sendStatus = (event) => {
        const isChecked = event.target.checked;
        if (!!setStatus) {
            setStatus(isChecked);
        }
    }

    return (
        <StldToggleSwitch style={{opacity: config.disabled === "disabled" ? ".4" : "1"}}>
            <CheckBoxWrapper>
                <CheckBox id={'checkbox' + (config?.id ?? config.name)} type="checkbox" checked={config.status} name={config.name} value={config.status} disabled={config.disabled} onChange={(e) => sendStatus(e)} />
                <CheckBoxLabel htmlFor={'checkbox' + (config?.id ?? config.name)} /> {config.label}
            </CheckBoxWrapper>
        </StldToggleSwitch>
    )
}